import React, { useContext, useEffect, useState } from 'react';
import { ContentChart } from '@meteor/frontend-core';
import { AppContext } from '../../../../contexts/AppContext';
import { GLOBAL_EVENT } from '../../../../consts/common/global-event';
import APIList from '../../../../http/ApiList';
import { cloneDeep, isObject, isString } from 'lodash';

const CustomizeTableChart: React.FC<any> = (props) => {
  const { authInfo, echartTheme, globalEvent, setGlobalEvent } = useContext(AppContext);
  const { property } = props;
  const [chartLoading, setChartLoading] = useState<any>(false);
  const [chartData, setChartData] = useState<any>(null);
  const [options, setOptions] = useState<any>({});
  const [chartOptions, setChartOptions] = useState<any>(null);
  const getChartData = (event: string) => {
    APIList.getCustomizeLayoutData()
      .post({ email: authInfo?.user?.attributes?.email || '', property, event })
      .then((res: any) => {
        setChartOptions(res.options);
        setTimeout(() => {
          setChartData(res.data);
          setChartLoading(false);
        });
      });
  };

  useEffect(() => {
    if (!property || !property.chartOptions || !property.chartOptions.options) {
      return;
    }
    let tempOptions = property.chartOptions.options;
    if (chartOptions) {
      tempOptions = chartOptions;
    }
    try {
      let op;
      if (tempOptions && isString(tempOptions)) {
        const reviver = (key, value) => {
          const arrowFunctionRegex = /^\s*\(?\s*([^)]*)\s*\)?\s*=>\s*{[^]*}$/;
          if (typeof value === 'string' && (value.startsWith('function') || arrowFunctionRegex.test(value))) {
            return new Function('return ' + value)();
          }
          return value;
        };
        const tempOp = JSON.parse(tempOptions, reviver);
        op = {
          ...options,
          ...tempOp,
        };
      } else if (tempOptions && isObject(tempOptions)) {
        op = tempOptions;
      }
      setOptions(cloneDeep({ ...op, echartTheme }));
    } catch (error) {}
  }, [property, chartOptions]);

  useEffect(() => {
    if (!globalEvent) {
      return;
    }
    if (
      (property.dataSource &&
        property.dataSource.triggerEvent &&
        property.dataSource.triggerEvent.find((triggerEvent) => {
          return triggerEvent.event === globalEvent.eventType;
        })) ||
      globalEvent.eventType === GLOBAL_EVENT.PAGE_INIT
    ) {
      setChartLoading(true);
      setTimeout(() => {
        getChartData(globalEvent);
      }, 500);
    }
  }, [globalEvent]);

  useEffect(() => {
    if (!chartData || chartData.length === 0) {
      return;
    }
    options.dataset = {
      source: chartData,
    };
    setOptions(cloneDeep({ ...options, echartTheme }));
  }, [chartData]);

  return (
    <>
      <ContentChart
        title={{
          value: (
            <>
              <span>{property.title}</span> <span style={{ float: 'right' }}>{property.subtitle}</span>
            </>
          ),
          styles: {},
        }}
        contentList={[]}
        chartOptions={options}
        showSeriesLabel={false}
        mouseWheelZoomLock={false}
        loading={chartLoading}
        height={'90%'}
        tooltips={['zoomIn']}
        isBank={!chartData || chartData.length === 0}
        onChartEvent={setGlobalEvent}
      />
    </>
  );
};

export default CustomizeTableChart;
